let skus = [
  {
    sku: 'J-WHT-100',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/wht-micro.png',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/white-micro-main.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/micro-white-3.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/micro-white-5.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/micro-white-1.jpg',
    ],
    name: 'Carrera White Micro',
    type: 'device',
    inStock: true,
    price: 395,
    notes: [
      '1 Josh Micro (Carrera White)',
      '1 USB-C cable & AC adapter',
      '1 POE Adapter',
      '1 Wall Mount with Screws',
      'Quick Start Guide',
      'Works with all software licenses',
    ],
  },
  {
    sku: 'J-BLK-100',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/blk-micro.png',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/black-micro-main.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/micro-black-3.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/micro-black-5.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/micro-black-2.jpg',
    ],
    name: 'Onyx Black Micro',
    price: 395,
    type: 'device',
    inStock: true,
    notes: [
      '1 Josh Micro (Onyx Black)',
      '1 USB-C cable & AC adapter',
      '1 POE Adapter',
      '1 Wall Mount with Screws',
      'Quick Start Guide',
      'Works with all software licenses',
    ],
  },
  {
    sku: 'J-ACC-MNT-CR-HA',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/ha-thumb.jpg',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/ha-thumb.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/ha-exp.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/shelf-top.jpg',
    ],
    name: 'Core Rack Mount - HA',
    price: 127,
    type: 'accessory',
    inStock: true,
    notes: [
      '1RU, double unit',
      'Middle Atlantic product',
      'Black brushed anodized',
      'Whole shelf',
    ],
  },
  {
    sku: 'J-ACC-MNT-CR-S',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/single-thumb.jpg',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/single-thumb.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/single-exp.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/shelf-top.jpg',
    ],
    name: 'Core Rack Mount - Single',
    price: 127,
    type: 'accessory',
    inStock: true,
    notes: [
      '1RU, single unit',
      'Middle Atlantic product',
      'Black brushed anodized',
      'Whole shelf',
    ],
  },
  {
    sku: 'J-CR-BLK-100',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/core-store-05.jpg',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/core-store-01.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/core-store-02.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/core-store-03.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/core-store-07.jpg',
    ],
    name: 'Core - Jet Black',
    price: 989,
    type: 'device',
    inStock: true,
    notes: [
      'Whole home processor',
      'Powered over POE',
      'Visit <a href="/core" class="detail-link" target="_blank">www.josh.ai/core</a> for more info',
    ],
  },
  {
    sku: 'J-NN-WHT-100',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/nano-white-crop.jpg',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/nano-white-style.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/nano-store-03.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/nano-store-06.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/nano-store-07.jpg',
    ],
    name: 'Josh Nano - Coral White',
    price: 395,
    type: 'device',
    inStock: true,
    notes: [
      'Ships with Nano Body & Cap, POE adapter',
      '1.6" diameter, 0.12" thick',
      'Visit <a href="/nano" class="detail-link" target="_blank">www.josh.ai/nano</a> for more info',
      '<span class="emphasis">Requires Josh Core to operate</span>',
    ],
  },
  {
    sku: 'J-XPT-XSP-1',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/Xspot.png',
    images: [],
    name: 'Pre-install Xspot Wire Device',
    price: 9.9,
    type: 'accessory',
    inStock: true,
    notes: [
      'Re-usable Wire Locator: Qty 1',
      'More info at <a href="http://www.xspotproducts.com/" class="detail-link" target="_blank">www.xspotproducts.com</a>',
      'Watch Nano pre-install video <a href="https://youtu.be/AB8dzsXTFP0" class="detail-link" target="_blank">here</a>',
      'MSRP: $12.95',
    ],
  },
  {
    sku: 'J-SWG-FRSB-1',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/frisbee_1.jpg',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/frisbee_1.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/frisbee_2.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/frisbee_3.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/frisbee_4.jpg',
    ],
    name: 'Josh Frisbee',
    price: 25,
    type: 'accessory',
    inStock: true,
    notes: [
      'Professional weight flying disc',
      'Perfect for kids, dogs, and integrators',
      '175 gram weight. 10 3/4" diameter',
      'Navy Blue',
    ],
  },
  {
    sku: 'J-XPT-XSM-1',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/Xstrap.png',
    images: [],
    name: 'Pre-install Xstrap mounting strap',
    price: 27.49,
    type: 'accessory',
    inStock: true,
    notes: [
      'Universal mounting strap',
      '60 foot roll: Qty 1',
      'More info at <a href="http://www.xspotproducts.com/" class="detail-link" target="_blank">www.xspotproducts.com</a>',
      'Watch Nano pre-install video <a href="https://youtu.be/AB8dzsXTFP0" class="detail-link" target="_blank">here</a>',
      'MSRP: $36.50',
    ],
  },
  {
    sku: 'J-XPT-XLBG-1',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/Xbundle.png',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/Xbundle.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/Xbag.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/Xcentric.png',
    ],
    name: 'Pre-install Xspot Locator Tools',
    price: 33.48,
    type: 'accessory',
    inStock: true,
    notes: [
      'Locate your Xspot behind the wall with the this tool set',
      'Includes the Xtreme Locator: Qty 1',
      'Includes the Xcentric: Qty 1',
      'Includes the Xbooty Bag: Qty 1',
      'More info at <a href="http://www.xspotproducts.com/" class="detail-link" target="_blank">www.xspotproducts.com</a>',
      'Watch Nano pre-install video <a href="https://youtu.be/AB8dzsXTFP0" class="detail-link" target="_blank">here</a>',
      'MSRP: $39.95',
    ],
  },
  {
    sku: 'J-XPT-XSK-1',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/Xstarter.png',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/Xstarter.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/Xspot.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/Xstrap.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/Xcentric.png',
    ],
    name: 'Pre-install Starter Kit',
    price: 70.87,
    type: 'accessory',
    inStock: true,
    notes: [
      'Pre-installation kit for Nano and Micro',
      'Includes the Xspot Re-usable Wire Device: Qty 1',
      'Includes the Xstrap Universal Mounting Strap 60 foot roll: Qty 1',
      'Includes the Xspot Locator tools: the Xtreme Locator: Qty 1, the Xcentric: Qty 1, the Xbooty Bag: Qty 1',
      'More info at <a href="http://www.xspotproducts.com/" class="detail-link" target="_blank">www.xspotproducts.com</a>',
      'Watch Nano pre-install video <a href="https://youtu.be/AB8dzsXTFP0" class="detail-link" target="_blank">here</a>',
      'MSRP: $89.40',
    ],
  },
  {
    sku: 'J-NN-BLK-100',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/nano-black-crop.jpg',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/nano-black-style.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/nano-store-01.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/nano-store-04.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/nano-black-led.jpg',
    ],
    name: 'Josh Nano - Jet Black',
    price: 395,
    type: 'device',
    inStock: true,
    notes: [
      'Ships with Nano Body & Cap, POE adapter',
      '1.6" diameter, 0.12" thick',
      'Visit <a href="/nano" class="detail-link" target="_blank">www.josh.ai/nano</a> for more info',
      '<span class="emphasis">Requires Josh Core to operate</span>',
    ],
  },
  {
    sku: 'J-NN-PAL-100',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/JoshLutron_PalladiomWhitePLUSNano_Front_LightBG_20220302_1.png',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/JoshLutron_PalladiomWhitePLUSNano_Front_LightBG_20220302_1.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/JoshLutron_PalladiomWhitePLUSNano_Front_LightBG_20220302_2.png',
    ],
    name: 'Josh Nano - Palladiom White',
    price: 395,
    type: 'device',
    inStock: true,
    notes: [
      "Specially built to work with Lutron's Josh.ai ready wall plates",
      'Ships with Nano Body & Cap, POE adapter',
      '1.6" diameter, 0.12" thick',
      'Requires <a href="https://luxury.lutron.com/us/en/controls/keypads/palladiom-keypad/josh-ai-ready-wallplate-2-gang-palladiom" target="_blank">Lutron Faceplate</a>',
      'Visit <a href="/nano" class="detail-link" target="_blank">www.josh.ai/nano</a> for more info',
      '<span class="emphasis">Requires Josh Core to operate</span>',
    ],
  },
  {
    sku: 'J-SFT-5R',
    name: '5 Room License',
    price: [200, 750, 2000],
    times: ['Annual', '5 Year', 'Lifetime'],
    skus: ['AN', 'FY', 'LT'],
    type: 'license',
    inStock: true,
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/josh-sft-lic-sm.svg',
  },
  {
    sku: 'J-SFT-BSC',
    name: 'Platform Access - Basic',
    price: [360, 1350, 3600],
    times: ['Annual', '5 Year', 'Lifetime'],
    skus: ['AN', 'FY', 'LT'],
    type: 'license',
    inStock: true,
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/josh-sft-lic-sm.svg',
  },
  {
    sku: 'J-SFT-LXR',
    name: 'Platform Access - Luxury',
    price: [720, 2700, 7200],
    times: ['Annual', '5 Year', 'Lifetime'],
    skus: ['AN', 'FY', 'LT'],
    type: 'license',
    inStock: true,
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/josh-sft-lic-lrg.svg',
  },
  {
    sku: 'J-SFT-15R',
    name: '15 Room License',
    price: [400, 1250, 4000],
    times: ['Annual', '5 Year', 'Lifetime'],
    skus: ['AN', 'FY', 'LT'],
    type: 'license',
    inStock: true,
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/josh-sft-lic-med.svg',
  },
  {
    sku: 'J-SFT-UR',
    name: 'Unlimited Rooms License',
    price: [600, 2250, 6000],
    times: ['Annual', '5 Year', 'Lifetime'],
    skus: ['AN', 'FY', 'LT'],
    type: 'license',
    inStock: true,
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/josh-sft-lic-lrg.svg',
  },
  {
    sku: 'J-SWG-STCK',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/stickers.jpg',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/stickers.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/sticker1.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/sticker2.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/sticker3.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/sticker4.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/sticker5.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/sticker6.png',
    ],
    name: 'Josh Sticker Pack',
    price: 5,
    type: 'stickers',
    inStock: true,
    notes: [
      '6 custom illustrated stickers per pack (exact stickers may vary)',
      'Die-cut vinyl',
      'Slap’em on your laptop, a processor in the rack, your office window, your cat/dog...',
    ],
  },
  {
    sku: 'J-ACC-WMK',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/wall-mount-ring-front.png',
    images: [],
    name: 'Wall Mount Kit',
    price: 15,
    type: 'accessory',
    inStock: true,
    notes: [
      'Magnetically attaches to Micro',
      'Comes with three screws',
      'Made for flat walls',
      'NOTE: This item is already included with each new order of Josh Micro. Use this to order replacement parts or additional quantity for stock.',
    ],
  },
  {
    sku: 'J-ACC-MSL',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/stand-hardware.png',
    images: [],
    name: 'Micro Stand Legs',
    price: 15,
    type: 'accessory',
    inStock: true,
    notes: [
      'Includes 2 Legs',
      'NOTE: This item is already included with each new order of Josh Micro. Use this to order replacement parts or additional quantity for stock.',
    ],
  },
  {
    sku: 'J-ACC-MSK',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/micro-stand.png',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/micro-stand.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/wall-mount-ring-front.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/stand-hardware.png',
    ],
    name: 'Micro Stand Kit',
    price: 30,
    type: 'accessory',
    inStock: true,
    notes: [
      'Magnetically attaches to Micro',
      'Pubberized contact points',
      'Includes 1 Metal Ring, 2 Legs, and 2 Screws',
      'NOTE: This item is already included with each new order of Josh Micro. Use this to order replacement parts or additional quantity for stock.',
    ],
  },
  {
    sku: 'J-SWG-BNE-2020',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/beanie-hero2.jpg',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/beanie-hero2.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/nader_beanie.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/felicia_beanie.jpg',
    ],
    name: 'Josh Beanie',
    price: 35,
    type: 'accessory',
    inStock: true,
    notes: [
      'Acrylic and polyester blend',
      'Laser etched with the Josh logo',
      '9.5in W x 7.5in L x 2in H',
      'Stretches to fit most head sizes',
    ],
  },
  {
    sku: 'J-SWG-CAP',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-hat-hero.jpg',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-hat-hero.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-hat-1.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-hat-3.jpg',
    ],
    name: 'Josh Baseball Cap',
    price: 30,
    type: 'accessory',
    inStock: true,
    notes: ['One size fits all', 'Embroidered with Josh logo', 'Color: Blue'],
  },
  {
    sku: 'J-SWG-GTR',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-gaiter-hero.jpg',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-gaiter-hero.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-gaiter-1.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-gaiter-2.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-gaiter-3.jpg',
    ],
    name: 'Josh Neck Gaiter',
    price: 15,
    type: 'accessory',
    inStock: true,
    notes: [
      'Can be used all year in any weather',
      'Comfortable polyester stretch, soft around the face to eliminate pressure to the ears and cheek bones',
      '100% Polyester',
      'Can be washed and reworn',
    ],
  },
  {
    sku: 'J-ACC-C6-W',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/usb-cable-short.png',
    images: [],
    name: 'White Power Cable (6 in)',
    price: 10,
    type: 'accessory',
    inStock: true,
    notes: [
      '6in Power Cable - White',
      'NOTE: This item is already included with each new order of Josh Micro. Use this to order replacement parts or additional quantity for stock.',
    ],
  },
  {
    sku: 'J-ACC-C6-B',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/usb-cable-short-black.png',
    images: [],
    name: 'Black Power Cable (6 in)',
    price: 10,
    type: 'accessory',
    inStock: true,
    notes: [
      '6in Power Cable - Black',
      'NOTE: This item is already included with each new order of Josh Micro. Use this to order replacement parts or additional quantity for stock.',
    ],
  },
  {
    sku: 'J-ACC-C60-W',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/usb-cable-long.png',
    images: [],
    name: 'White Power Cable (60 in)',
    price: 10,
    type: 'accessory',
    inStock: true,
    notes: ['60in Power Cable - White'],
  },
  {
    sku: 'J-ACC-C60-B',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/usb-cable-long-black.png',
    images: [],
    name: 'Black Power Cable (60 in)',
    price: 10,
    type: 'accessory',
    inStock: true,
    notes: ['60in Power Cable - Black'],
  },
  {
    sku: 'J-ACC-P6-W',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/poe-adapter-short-white.png',
    images: [],
    name: 'White Micro POE Adapter (6 in)',
    price: 35,
    type: 'accessory',
    inStock: true,
    notes: [
      'Micro POE Adapter with 6in cable attached - White',
      'NOTE: This item is already included with each new order of Josh Micro. Use this to order replacement parts or additional quantity for stock.',
    ],
  },
  {
    sku: 'J-ACC-P6-NN-W',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/nano-poe.png',
    images: [],
    name: 'White Nano POE Adapter (6 in)',
    price: 35,
    type: 'accessory',
    inStock: true,
    notes: [
      'Nano POE Adapter with 6in cable attached - White',
      'NOTE: This item does not work with Josh Micro',
      'NOTE: This item is already included with each new order of Josh Nano. Use this to order replacement parts or additional quantity for stock.',
      'Will be shipping January 2022',
    ],
  },
  {
    sku: 'J-ACC-P6-B',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/poe-adapter-short-black.png',
    images: [],
    name: 'Black Micro POE Adapter (6 in)',
    price: 35,
    type: 'accessory',
    inStock: true,
    notes: [
      'Micro POE Adapter with 6in cable attached - Black',
      'NOTE: This item is already included with each new order of Josh Micro. Use this to order replacement parts or additional quantity for stock.',
    ],
  },
  {
    sku: 'J-ACC-P24-W',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/poe-adapter-long-white.png',
    images: [],
    name: 'White Micro POE Adapter (24 in)',
    price: 35,
    type: 'accessory',
    inStock: true,
    notes: [
      'Micro POE Adapter with 24in cable attached - White',
      'NOTE: This item is already included with each new order of Josh Micro. Use this to order replacement parts or additional quantity for stock.',
    ],
  },
  {
    sku: 'J-ACC-P24-B',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/poe-adapter-long-black.png',
    images: [],
    name: 'Black Micro POE Adapter (24 in)',
    price: 35,
    type: 'accessory',
    inStock: true,
    notes: [
      'Micro POE Adapter with 24in cable attached - Black',
      'NOTE: This item is already included with each new order of Josh Micro. Use this to order replacement parts or additional quantity for stock.',
    ],
  },
  {
    sku: 'J-ACC-TFR-W',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/ac-adapter.png',
    images: [],
    name: 'White Wall Transformer',
    price: 10,
    type: 'accessory',
    inStock: true,
    notes: [
      'Wall Transformer - White',
      'NOTE: This item is already included with each new order of Josh Micro. Use this to order replacement parts or additional quantity for stock.',
    ],
  },
  {
    sku: 'J-ACC-TFR-B',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/ac-adapter-black.png',
    images: [],
    name: 'Black Wall Transformer',
    price: 10,
    type: 'accessory',
    inStock: true,
    notes: [
      'Wall Transformer - Black',
      'NOTE: This item is already included with each new order of Josh Micro. Use this to order replacement parts or additional quantity for stock.',
    ],
  },
  {
    sku: 'J-SWG-RBS',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-rainbow-shirt-hero.jpg',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-rainbow-shirt-hero.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-rainbow-shirt-1.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-rainbow-shirt-2.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-rainbow-shirt-3.jpg',
    ],
    name: 'Josh Rainbow Short Sleeve Shirt',
    price: 25,
    type: 'accessory',
    inStock: true,
    notes: [],
  },
  {
    sku: 'J-SWG-DL',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-logo-shirt-hero.jpg',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-logo-shirt-hero.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-logo-shirt-1.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-logo-shirt-2.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-logo-shirt-3.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/josh-logo-shirt-4.jpg',
    ],
    name: 'Josh Logo Short Sleeve Shirt',
    price: 25,
    type: 'accessory',
    inStock: true,
    notes: [],
  },
  {
    sku: 'J-SWG-BRC-2021',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/brochure.jpg',
    images: [],
    name: 'Josh Brochures',
    price: 20,
    type: 'brochure',
    inStock: true,
    notes: [
      '20 pack of Josh customer brochures',
      'Printed on semi-gloss paper',
      'Link to digital brochure <a href="https://d35408cyocioye.cloudfront.net/new3/resources/Josh-Client-Brochure-Digital-2021.pdf" class="detail-link" target="_blank">here</a>',
      '2021 edition',
    ],
  },
  {
    sku: 'J-ACC-CVR-SQR',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/covers/cover-sqr.png',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/covers/cover-sqr.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/covers/sqr2.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/covers/sqr3.png',
    ],
    name: 'Square Paintable Nano Covers',
    price: 49,
    type: 'accessory',
    inStock: true,
    notes: [
      'Quantity: 3 Square Covers',
      'Designed to be painted to match any surface. When the Nano Covers are used, the client will not be able to access the mute switch or see the LEDs.',
    ],
  },
  {
    sku: 'J-ACC-CVR-RND',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/covers/cover-rnd.png',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/covers/cover-rnd.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/covers/rnd2.png',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/products/covers/rnd3.png',
    ],
    name: 'Round Paintable Nano Covers',
    price: 49,
    type: 'accessory',
    inStock: true,
    notes: [
      'Quantity: 3 Round Covers',
      'Designed to be painted to match any surface. When the Nano Covers are used, the client will not be able to access the mute switch or see the LEDs.',
    ],
  },
  {
    sku: 'J-PA-BASIC',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/JoshGiftCard_White2.png',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/platform-access-basic-front.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/platform-access-basic-rear.jpg',
    ],
    name: 'Basic Platform Access',
    price: 49,
    type: 'license',
    inStock: true,
    notes: [
      'Delivered as a physical card to redeem - if you need immediate access, please select Digital Delivery',
      'Up to 9 rooms of control',
      'Unlimited number of users',
      'Unlimited number of controllable devices',
      'Free Josh app for iOS and Android',
      'Continuous over-the-air software updates',
    ],
    subSKUs: [
      {
        digitalSKU: 'J-SFT-BSC-AN',
        cardSKU: 'J-CRD-BSC-AN',
        name: 'Annual',
        price: 360,
      },
      {
        digitalSKU: 'J-SFT-BSC-FY',
        cardSKU: 'J-CRD-BSC-FY',
        name: '5 Year',
        price: 1350,
      },
      {
        digitalSKU: 'J-SFT-BSC-LT',
        cardSKU: 'J-CRD-BSC-LT',
        name: 'Lifetime',
        price: 3600,
      },
    ],
  },
  {
    sku: 'J-PA-LUXURY',
    image:
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/JoshGiftCard_Black2.png',
    images: [
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/platform-access-luxury-front.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/platform-access-luxury-rear.jpg',
      'https://d35408cyocioye.cloudfront.net/new3/integrator-portal/GiftBoxPlusBooklet_20211111_1-crop.jpg',
    ],
    name: 'Luxury Platform Access',
    price: 49,
    type: 'license',
    inStock: true,
    notes: [
      'Delivered as a physical card to redeem - if you need immediate access, please select Digital Delivery',
      '10 or more rooms of control',
      'Unlimited number of users',
      'Unlimited number of controllable devices',
      'Free Josh app for iOS and Android',
      'Continuous over-the-air software updates',
    ],
    subSKUs: [
      {
        digitalSKU: 'J-SFT-LXR-AN',
        cardSKU: 'J-CRD-LXR-AN',
        name: 'Annual',
        price: 720,
      },
      {
        digitalSKU: 'J-SFT-LXR-FY',
        cardSKU: 'J-CRD-LXR-FY',
        name: '5 Year',
        price: 2700,
      },
      {
        digitalSKU: 'J-SFT-LXR-LT',
        cardSKU: 'J-CRD-LXR-LT',
        name: 'Lifetime',
        price: 7200,
      },
    ],
  },
];
